import React, { FC, useContext, useEffect, useState } from 'react'
import { Button, CTA } from '@components/ui'
import { Typography } from '@mui/material'
import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useRouter } from 'next/router'
import { useStore } from '@utils/hooks'
import TextField from '@components/ui/TextField'
import routes from '@const/routes'
import { RedirectContext } from '@utils/context/redirectContext'
import { AbstractLabel } from '@core/models/abstractLabel'

interface IFormInputs {
  email: string
  password: string
}

const defaultValues: IFormInputs = {
  email: '',
  password: ''
}

const schema = yup.object().shape({
  email: yup
    .string()
    .matches(/.{2,}/, {
      message: 'L‘email ou l‘identifiant doit comporter au moins 2 caractères!'
    })
    .required('L‘email ou identifiant est requis!'),
  password: yup
    .string()
    .matches(/.{2,}/, {
      message: 'Le mot de passe doit comporter au moins 2 caractères!'
    })
    .required('Le mot de passe est requis')
})

interface Props {}

const LoginForm: FC<Props> = () => {
  const router = useRouter()
  const { redirectTo, setRedirectTo } = useContext(RedirectContext)

  const { store } = useStore()
  const [formValues] = useState<IFormInputs>(defaultValues)

  const { email, password } = formValues

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<IFormInputs>({
    resolver: yupResolver(schema)
  })

  const onSubmit: SubmitHandler<IFormInputs> = async data => {
    try {
      if (store && store.meStore) store.meStore.tenant = new AbstractLabel({ id: Number(process.env.TENANT_ID), label: 'Super Ya' })
      await store?.meStore?.login(data.email, data.password)
      if (redirectTo) {
        router.push(redirectTo)
        setRedirectTo(null)
      } else {
        router.push(routes.mon_compte_mon_profil.uri)
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    for (const error of Object.values<any>(errors)) {
      if (error?.ref) {
        let firstErrorElement = document.getElementsByName(error.ref.name)[0]
        firstErrorElement.scrollIntoView({ behavior: 'smooth' })
        break
      }
    }
  }, [errors])

  return (
    <>
      <form method="POST" onSubmit={handleSubmit(onSubmit)} className="flex flex-col justify-between space-y-5">
        <TextField id="email" label="Email ou identifiant *" name="email" placeholder="Entrer mon email" fullWidth control={control} defaultValue={email} />
        <TextField id="password" label="Mot de passe *" name="password" placeholder="Entrer mon mot de passe" fullWidth type="password" control={control} defaultValue={password} />
        <CTA url={routes.mot_de_passe_oublie.uri} label="Mot de passe oublié ?" classes="w-full text-right" />
        <Button variant="contained" color="primary" type="submit">
          Se connecter
        </Button>
        <Typography>* Tous les champs sont obligatoires</Typography>
      </form>
    </>
  )
}

export default LoginForm
